export default "__VITE_PUBLIC_ASSET__fc8e98cd__"